import React, {useEffect, useMemo, useState} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {StatusPatientsColumnFormatter} from "../../../component/table/column-formatters/StatusColumnFormatter";
import {
    GenderColumnFormatter,
    NominativeColumnFormatter
} from "../../../component/table/column-formatters/TypeColumnFormatter";
import {defaultPatientSorted} from "../PatientsUIHelpers";
import {} from "../../../../_metronic/_helpers";
import {usePatientsUIContext} from "../PatientsUIContext";
import * as actions from "../../../actions/patients/patientsActions";
import {tableSortByDate} from "../../../component/table/tableSort";
import {InfiniteScrollTable} from "../../../component/table/InfiniteScrollTable";
import {ExportButton} from "../../../component/exportbutton/ExportButton";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import {useLanguageForShared} from "../../../../shared/utils/languages/useLanguageForShared";
import {selectSelectedCustomer} from "../../../actions/users/usersSlice";

export function PatientsTable() {
    const {t} = useLanguageForShared()

    const dispatch = useDispatch();
    const selectedCustomer = useSelector(selectSelectedCustomer)
    // Patients UI Context
    const patientsUIContext = usePatientsUIContext();
    const patientsUIProps = useMemo(() => {
        return {
            queryParams: patientsUIContext.queryParams,
            openInfoPatientPage: patientsUIContext.openInfoPatientPage,
        };
    }, [patientsUIContext]);

    const {currentState} = useSelector(
        (state) => ({currentState: state.patients}),
        shallowEqual
    );

    const { patientsList, pagination, filterPatientProviders, totalCount } = currentState;

    const [selectedRows, setSelectedRows] = useState([]);
    const [sortTable, setSortTable] = useState(undefined);

    useEffect(() => {
        if (sortTable) {
            dispatch(actions.fetchPatients(patientsUIProps.queryParams, null, sortTable));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [patientsUIProps.queryParams, selectedCustomer]);

    const columns = [
        {
            dataField: "Id",
            text: t('lsi.table.code'),
            sort: true
        },
        {
            dataField: "Nominative",
            text: t('lsi.table.patient'),
            sort: true
        },
        {
            dataField: "Gender",
            text: t('lsi.table.gender'),
            sort: true,
            formatter: GenderColumnFormatter
        },
        {
            dataField: "FiscalCode",
            text: t('lsi.table.fiscalCode'),
            sort: false
        },
        {
            dataField: "District",
            text: t('lsi.table.district'),
            sort: true
        },
        {
            dataField: "Status",
            text: t('lsi.table.status'),
            sort: true,
            formatter: StatusPatientsColumnFormatter,
        },
        ...filterPatientProviders.length > 1? [{
            dataField: "Provider",
            text: t('lsi.table.provider'),
            sort: true
        }]: [],
        {
            dataField: "Prescriptions",
            text: t('lsi.table.treatment'),
            sort: true
        },
        {
            dataField: "Provision",
            text: t('lsi.table.provision'),
            sort: true
        },
        {
            dataField: "InchargeDate",
            text: t('lsi.table.dateTaking'),
            sort: true,
            sortFunc: tableSortByDate
        },
        {
            dataField: "DischargeDate",
            text: t('lsi.table.dateDisposal'),
            sort: true,
            sortFunc: tableSortByDate
        },
        {
            dataField: "TherapyDays",
            text: t('lsi.table.terapyDays'),
            sort: true
        }
    ];

    return (
        <Card className="customHeaderPadding">
            <CardHeader title={t('lsi.listTreatments')} className="fw-bolder">
                <CardHeaderToolbar>
                    <ExportButton
                        data={selectedRows.length > 0 ? selectedRows : []}
                        loadData={(callback) => dispatch(actions.fetchPatientsForFile(patientsUIProps.queryParams, sortTable, callback))}
                        columns={columns}
                        fileName={"trattamenti"}
                    />
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <InfiniteScrollTable
                    keyField={"PrescriptionId"}
                    id={"patientTable"}
                    columns={columns}
                    data={patientsList}
                    defaultSorted={defaultPatientSorted}
                    pagination={pagination}
                    onSelectRow={patientsUIProps.openInfoPatientPage}
                    onSelectCheckBox={(row, isSelect) => {
                        if (isSelect) {
                            setSelectedRows([...selectedRows, row]);
                        } else {
                            setSelectedRows(selectedRows.filter((el) => {
                                return el.Id !== row.Id
                            }));
                        }
                    }}
                    hoverEnable={true}
                    loadData={(event, tableInfo) => {
                        if (tableInfo) {
                            setSortTable({dataField: tableInfo.sortField, order: tableInfo.sortOrder});
                            dispatch(actions.fetchPatients(patientsUIProps.queryParams, (event === "sort" ? null : pagination), {
                                dataField: tableInfo.sortField,
                                order: tableInfo.sortOrder
                            }, true));
                        } else {
                            dispatch(actions.fetchPatients(patientsUIProps.queryParams, pagination, sortTable, false));
                        }
                    }}
                    noData={t('lsi.noDataAvailable')}
                />
            </CardBody>
        </Card>
    );
}
